export default __webpack_public_path__ + "static/media/recuperacaoCredito.54341a75.png";